<template lang="pug">
#modal-sucesso-inclusao-pssc
    el-dialog(
        :title='modalSucessoInclusao',
        :width='width',
        :visible.sync='show_',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        show-close,
        @close='closeDialog()'
    )

        .success-icon
            i.el-icon.icon-success-filled-verde(
                class='el-icon-success'
            )

            div.notificacao_sucesso-texto
                | {{ $t('mensagens.pssc.telaIncluirTerritorios.enviadoComSucesso') }}

            div.descricao_sucesso-texto
                p {{ $t('mensagens.pssc.telaIncluirTerritorios.mensagemEnviamosTeritoriosAnalise') }}
                p {{ $t('mensagens.pssc.telaIncluirTerritorios.mensagemAcompanharGestaoLotes') }}

        .dialog-footer(slot='footer')
            el-button.outline-button(
                type='outline',
                size='mini',
                @click='closeDialog'
            ) {{ $t('mensagens.comuns.fechar') }}
</template>

<script>

export default {
    name: 'ModalNotificacaoSucessoPssc',
    emits: ['fecharNotificacaoSucesso'],
    components: { },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: false
        }
    },

    data() {
        return {
            modalSucessoInclusao: 'SUCESSO_INCLUSAO',
            show_: false,
            width: '50%'
        };
    },

    watch: {
        show: {
            handler() {
                this.show_ = this.show;

                var elements = document.getElementsByClassName('el-dialog__header');
                for (var i = 0; i < elements.length; i++) {
                    if (elements[i].innerText === this.modalSucessoInclusao) {
                        elements[i].style.backgroundColor = 'var(--white) !important';
                    }
                }

                var titles = document.getElementsByClassName('el-dialog__title');
                for (var j = 0; j < titles.length; j++) {
                    if (titles[j].innerText === this.modalSucessoInclusao) {
                        titles[j].style.visibility = 'hidden';
                    }
                }
            },
            immediate: true
        }
    },

    methods: {
        closeDialog() {
            this.show_ = false;
            this.$emit('closeDialog');
            this.$emit('fecharNotificacaoSucesso');
        }
    }
};
</script>

<style lang="scss">
#modal-sucesso-inclusao-pssc {
    .success-icon {
        .icon-success-filled-verde {
            color: #359138 !important;
            font-size: 75px;
            width: 100%;
            text-align: center;
            height: fit-content;
            padding: 8px 0;
            margin-top: 25px;
        }
        .notificacao_sucesso-texto {
            color: #359138 !important;
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-weight: 500;
        }
        .descricao_sucesso-texto {
            width: 100%;
            text-align: center;
            font-weight: 500;
            margin: 15px 0;
            p {
                margin: 5px 0 !important;
            }
        }
    }

    .el-dialog__footer {
        margin-top: 0;
        text-align: right;
        border-top: solid 2px #e7e7e7;
        background-color: #ffffff;

        .dialog-footer {
            display: flex;
            justify-content: space-around !important;
            gap: 16px;
        }
    }

    .el-dialog__close {
        color: #3B3B3B;
        &:before {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .outline-button {
        margin: 0px !important;
    }

    .primary-button {
        margin: 0px !important;
    }

    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 20px;
        background-color: #ffffff;
        padding-bottom: 0;
        span {
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        padding: 15px 20px !important;
        background-color: #e9e9e9;
        .el-dialog__title {
            color: #00413c;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .el-dialog__body {
        max-height: 525px;
        padding: 15px;
    }

    .el-divider--horizontal {
        margin: 15px 0 8px 0;
    }
}
</style>
